import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, DefaultButton, Dropdown } from "@fluentui/react";
import { Spinner, SpinnerSize } from '@fluentui/react';
import { changeStatus } from 'store/actions/syncUsersActions';

const ChangeStatusDrawer = ({
    closeDrawer,
    selectedUserIds = [],
    clearSelection,
    onStatusChanged,
    onRefresh,
}) => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.syncUsers || { loading: false });
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showError, setShowError] = useState(false);
    const [touched, setTouched] = useState(false);

    const statusOptions = [
        { key: 2, text: 'Activate' },
        { key: 3, text: 'Deactivate' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedStatus === null || selectedStatus === undefined) {
            setShowError(true);
            return;
        }

        if (selectedUserIds.length === 0) return;

        setIsSubmitting(true);
        try {
            await dispatch(changeStatus('/users/update-status', {
                userIds: selectedUserIds,
                status: selectedStatus
            }));

            if (onStatusChanged) {
                onStatusChanged(selectedUserIds, selectedStatus);
            }

            if (clearSelection) {
                clearSelection();
            }
            
            closeDrawer();
        } catch (error) {
            console.error('Failed to change user status:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div className="drawer">
                <div className="drawer-loading">
                    <Spinner size={SpinnerSize.large} label="Loading..." />
                </div>
            </div>
        );
    }

    return (
        <div className="drawer-backdrop">
            <div className="drawer">
                <div className="drawer-header">
                    <div className="heading">
                        Change Status
                    </div>
                    <button className="close-btn" onClick={closeDrawer}>&times;</button>
                </div>
                <div className="drawer-content">
                    <form className="form-content" onSubmit={handleSubmit}>
                        <div>
                            <div className="row">
                                <div className="col-12">
                                    <div style={{ marginBottom: '10px' }}>
                                        Selected Users: <strong>{selectedUserIds.length}</strong>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <Dropdown
                                        label="Select Status"
                                        placeholder="Select a status"
                                        options={statusOptions}
                                        selectedKey={selectedStatus}
                                        onChange={(e, option) => {
                                            setSelectedStatus(option.key);
                                            setShowError(false);
                                            setTouched(true);
                                        }}
                                        onBlur={() => {
                                            setTouched(true);
                                            if (!selectedStatus) {
                                                setShowError(true);
                                            }
                                        }}
                                        errorMessage={(showError || touched) && !selectedStatus ? "Please select a status" : undefined}
                                        styles={{
                                            dropdown: { width: '100%' }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-12">
                                <div className="d-flex justify-content-end">
                                    <DefaultButton
                                        text="Cancel"
                                        onClick={closeDrawer}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <PrimaryButton
                                        text={isSubmitting ? "Submitting..." : "Submit"}
                                        type="submit"
                                        disabled={selectedUserIds.length === 0 || isSubmitting}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangeStatusDrawer;